import { routes } from 'src/constans/routes';

export const checkErrorFromRequest = status => {
  if (status === 401 || status === 403 || status === 500) {
    return routes.LOGIN;
  }
};
